import React, { useState, useContext } from "react";
import useForm from "react-hook-form";

import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import config from "../../dashboard-config";

import { SessionContext } from "../../context/SessionContext";
import { UIContext } from "../../context/UIContext";

const useStyles = makeStyles({
  accessForm: {
    background: "transparent",
    boxShadow: "none",
    color: "#FFF",
    textAlign: "left",
    width: "60vw"
  },
  buttonSeparator: {
    fontSize: "0.8em",
    padding: "1em 3em",
    "@media only screen and (min-width: 450px)": {
      padding: "0 2em",
      display: "inline"
    }
  },
  dialogTitle: {
    background: "#43475B",
    fontSize: "40px",
    fontWeight: "bold",
    padding: "1em 2em 1em 1.5em",
    textAlign: "left",
    "@media only screen and (max-width: 650px)": {
      fontSize: "30px"
    },
    "@media only screen and (max-width: 450px)": {
      fontSize: "20px"
    }
  },
  inputField: {
    background: "#171F31",
    color: "#FFF",
    padding: "0",
    margin: "0 0 1vh 0",
    width: "20vw",
    "@media only screen and (max-width: 640px)": {
      width: "40vw"
    },
    "@media only screen and (max-width: 450px)": {
      width: "60vw"
    }
  },
  inputLabel: {
    fontWeight: "bold",
    paddingBottom: "1em"
  },
  requestErrors: {
    color: "#FFB122",
    margin: "2vh 0 0 0"
  },
  textInputField: {
    background: "#171F31",
    color: "#FFF",
    padding: "0",
    margin: "0 0 2em 0",
    width: "71.5%",
    "@media only screen and (max-width: 640px)": {
      width: "100%"
    }
  },
  textInputFieldStyle: {
    color: "#FFF"
  },
  title: {
    fontSize: 14
  }
});

const RequestAccess = ({ handleClose }) => {
  const classes = useStyles();

  const { setToken } = useContext(SessionContext);
  const { setModalState } = useContext(UIContext);

  const { register, handleSubmit } = useForm({});
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyOrg, setCompanyOrg] = useState("");
  const [isError, setIsError] = useState(false);
  const profile = JSON.parse(localStorage.getItem("sofar-user") || "{}");

  const postSubscribe = async data => {
    /* URI encoding object */
    const description = data.description ? data.description : "";
    let details = {
      firstName: data.firstname,
      lastName: data.lastname,
      companyOrg: data.company,
      description: description
    };

    let formBody = [];
    for (let property in details) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(details[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    fetch(`${config.wavefleetUrl}/oceans-api/get-trial-api`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        token: profile.token
      }),
      body: formBody
    })
      .then(res => {
        if (res.status === 200) {
          res.json().then(data => {
            setToken(data.data.token);
            setModalState(3);
          });
        } else {
          setIsError(true);
        }
      })
      .catch(e => setIsError(true));
  };

  return (
    <React.Fragment>
      <DialogTitle
        id="responsive-dialog-title"
        className={classes.dialogTitle}
        disableTypography={true}
      >
        {"Get instant free trial API access"}
        <Button
          style={{ float: "right", transform: "translate(40px, 0)" }}
          onClick={handleClose}
        >
          <CloseIcon style={{ color: "#FFF", transform: "scale(1.8)" }} />
        </Button>
      </DialogTitle>
      <DialogContent
        style={{ background: "#33374B", padding: "2em 4em 4em 4em" }}
      >
        <Paper className={classes.accessForm}>
          <Typography variant="subtitle1" style={{ fontSize: "0.9em" }}>
            Fill out the following information and get 30-day free trial access
            to the API.
          </Typography>

          <hr
            style={{
              border: "2px solid #43475B",
              width: "40%",
              marginTop: "2em"
            }}
          />

          {isError && (
            <Typography className={classes.requestErrors}>
              You already have a trial
            </Typography>
          )}

          <Grid container spacing={6} style={{ padding: "2em 2em 0 0" }}>
            <Grid item>
              <form className={classes.root} noValidate autoComplete="off">
                <Typography variant="subtitle1" className={classes.inputLabel}>
                  First Name
                </Typography>
                <TextField
                  id="firstname-field"
                  className={classes.inputField}
                  InputProps={{
                    className: classes.textInputFieldStyle
                  }}
                  name="firstname"
                  margin="normal"
                  size="small"
                  variant="outlined"
                  onChange={e => setFirstName(e.target.value)}
                  inputRef={register({
                    required: "Field is empty!"
                  })}
                  inputProps={{ tabIndex: "1" }}
                />
                <Typography
                  variant="subtitle1"
                  className={classes.inputLabel}
                  style={{ paddingTop: "1em" }}
                >
                  Company / Organization
                </Typography>
                <TextField
                  id="company-field"
                  className={classes.inputField}
                  InputProps={{
                    className: classes.textInputFieldStyle
                  }}
                  name="company"
                  margin="normal"
                  size="small"
                  variant="outlined"
                  onChange={e => setCompanyOrg(e.target.value)}
                  inputRef={register({
                    required: "Field is empty!"
                  })}
                  inputProps={{ tabIndex: "3" }}
                />
              </form>
            </Grid>
            <Grid item>
              <form className={classes.root} noValidate autoComplete="off">
                <Typography variant="subtitle1" className={classes.inputLabel}>
                  Last Name
                </Typography>
                <TextField
                  id="lastname-field"
                  className={classes.inputField}
                  InputProps={{
                    className: classes.textInputFieldStyle
                  }}
                  name="lastname"
                  margin="normal"
                  size="small"
                  variant="outlined"
                  onChange={e => setLastName(e.target.value)}
                  inputRef={register({
                    required: "Field is empty!"
                  })}
                  inputProps={{ tabIndex: "2" }}
                />
              </form>
            </Grid>
          </Grid>
          <form className={classes.root} noValidate autoComplete="off">
            <Typography
              variant="subtitle1"
              className={classes.inputLabel}
              style={{ paddingTop: "1em" }}
            >
              Please describe how you’ll be using the API
            </Typography>
            <TextField
              id="description-field"
              className={classes.textInputField}
              InputProps={{
                className: classes.textInputFieldStyle
              }}
              name="description"
              margin="normal"
              multiline={true}
              rows={5}
              rowsMax={8}
              variant="outlined"
              inputRef={register}
              inputProps={{ tabIndex: "4" }}
            />
          </form>
          {firstName && lastName && companyOrg && (
            <Button
              variant="contained"
              style={{
                backgroundColor: "#228CBD",
                borderRadius: "2px",
                color: "#FFF",
                fontSize: "0.8em",
                fontWeight: "bold",
                padding: "0.5em 1em 0.5em 1em",
                textTransform: "none"
              }}
              onClick={handleSubmit(postSubscribe)}
            >
              Start 30-day Trial
            </Button>
          )}
          {/* <Typography
                                variant='subtitle1'
                                className={classes.buttonSeparator}
                            >
                                or
                        </Typography>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: 'transparent', border: '3px solid #228CBD', borderRadius: '2px', color: '#FFF', fontSize: '0.8em', fontWeight: 'bold', padding: '0.5em 2em 0.5em 2em', textTransform: 'none' }}
                        >
                            Buy Now
                        </Button> */}
        </Paper>
      </DialogContent>
    </React.Fragment>
  );
};

export default RequestAccess;
